<!--*ngIf="show"-->
<ng-container *ngIf="show">
    <div class="fixed w-full h-full flex left-0 justify-content-center align-items-center top-0 loader-Img ">
      <svg class="pl" width="240" height="240" viewBox="0 0 240 240">
	<circle class="pl__ring pl__ring--a" cx="120" cy="120" r="105" fill="none" stroke="#000" stroke-width="20"
          stroke-dasharray="0 660" stroke-dashoffset="-330" stroke-linecap="round"></circle>
	<circle class="pl__ring pl__ring--b" cx="120" cy="120" r="35" fill="none" stroke="#000" stroke-width="20"
          stroke-dasharray="0 220" stroke-dashoffset="-110" stroke-linecap="round"></circle>
	<circle class="pl__ring pl__ring--c" cx="85" cy="120" r="70" fill="none" stroke="#000" stroke-width="20"
          stroke-dasharray="0 440" stroke-linecap="round"></circle>
	<circle class="pl__ring pl__ring--d" cx="155" cy="120" r="70" fill="none" stroke="#000" stroke-width="20"
          stroke-dasharray="0 440" stroke-linecap="round"></circle>
   </svg>
    </div>
</ng-container>


<!--<div class="layout-preloader-container">-->
<!--  <div class="layout-preloader-content">-->
<!--    <svg class="layout-preloader" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">-->
<!--      <circle class="layout-preloader-path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>-->
<!--    </svg>-->
<!--  </div>-->
<!--</div>-->
